var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"mt-1",attrs:{"cols":"12"}},[_c('schedule-as-soon-as-posible',{model:{value:(_vm.deliveryTime),callback:function ($$v) {_vm.deliveryTime=$$v},expression:"deliveryTime"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }